import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
export const ExampleComponent = () => {
    const [count, setCount] = useState(0);
    const AddOne = useCallback(() => {
        setCount((count) => count + 1);
    }, []);
    return (_jsxs("div", { children: ["Example React Component: ", count, " ", _jsx("button", Object.assign({ onClick: AddOne }, { children: "+1" }), void 0)] }, void 0));
};
//# sourceMappingURL=react-lib.js.map